export {EventListener} from '@modules/communication-center/core/event-listener.class';
export {CommunicationRoom} from './core/communication-room.class';
export {CommunicationCenterService} from './core/communication-center.service';
export {CommunicationCenterModule} from './core/communication-center.module';
